export default "__VITE_ASSET__BmJ3N77B__"